// ---文字変換処理---
// 半角から全角へ変換
const han2ZenAll = function (str) {
  return han2ZenLtrNum(han2ZenSign(han2ZenKana(str))).replace(/[\x20]/g, '　')
}

// 半角英数字を全角へ変換
const han2ZenLtrNum = function (str) {
  return str.replace(/[A-Za-z0-9]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) + 0xFEE0)
  })
}

// 半角記号を全角へ変換
const han2ZenSign = function (str) {
  let convertMap = { '｡': '。', '､': '、', '｢': '「', '｣': '」', '･': '・', ﾞ: '゛' }
  convertMap = { ...convertMap, ﾟ: '゜', '"': '”', '\'': '‘', '―': 'ー' } // できないが必要ない'\\':'￥'
  const reg = new RegExp('(' + Object.keys(convertMap).join('|') + ')', 'g')
  str = str.replace(reg, function (match) { return convertMap[match] })
  const halfVal = str.replace(/[!-@[-`{-~]/g, function (tempStr) {
    // 文字コードをシフト
    return String.fromCharCode(tempStr.charCodeAt(0) + 0xFEE0)
  })
  // 文字コードシフトで対応できない文字の変換
  return halfVal
}

// 半角カナから全角カナへ変換、半角全角変換では不十分らしい
const han2ZenKana = function (str) {
  let convertMap = { ｶﾞ: 'ガ', ｷﾞ: 'ギ', ｸﾞ: 'グ', ｹﾞ: 'ゲ', ｺﾞ: 'ゴ', ｻﾞ: 'ザ', ｼﾞ: 'ジ', ｽﾞ: 'ズ', ｾﾞ: 'ゼ', ｿﾞ: 'ゾ' }
  convertMap = { ...convertMap, ﾀﾞ: 'ダ', ﾁﾞ: 'ヂ', ﾂﾞ: 'ヅ', ﾃﾞ: 'デ', ﾄﾞ: 'ド', ﾊﾞ: 'バ', ﾋﾞ: 'ビ', ﾌﾞ: 'ブ', ﾍﾞ: 'ベ', ﾎﾞ: 'ボ' }
  convertMap = { ...convertMap, ﾊﾟ: 'パ', ﾋﾟ: 'ピ', ﾌﾟ: 'プ', ﾍﾟ: 'ペ', ﾎﾟ: 'ポ', ｳﾞ: 'ヴ', ﾜﾞ: 'ヷ', ｦﾞ: 'ヺ' }
  convertMap = { ...convertMap, ｱ: 'ア', ｲ: 'イ', ｳ: 'ウ', ｴ: 'エ', ｵ: 'オ', ｶ: 'カ', ｷ: 'キ', ｸ: 'ク', ｹ: 'ケ', ｺ: 'コ' }
  convertMap = { ...convertMap, ｻ: 'サ', ｼ: 'シ', ｽ: 'ス', ｾ: 'セ', ｿ: 'ソ', ﾀ: 'タ', ﾁ: 'チ', ﾂ: 'ツ', ﾃ: 'テ', ﾄ: 'ト' }
  convertMap = { ...convertMap, ﾅ: 'ナ', ﾆ: 'ニ', ﾇ: 'ヌ', ﾈ: 'ネ', ﾉ: 'ノ', ﾊ: 'ハ', ﾋ: 'ヒ', ﾌ: 'フ', ﾍ: 'ヘ', ﾎ: 'ホ' }
  convertMap = { ...convertMap, ﾏ: 'マ', ﾐ: 'ミ', ﾑ: 'ム', ﾒ: 'メ', ﾓ: 'モ', ﾔ: 'ヤ', ﾕ: 'ユ', ﾖ: 'ヨ' }
  convertMap = { ...convertMap, ﾗ: 'ラ', ﾘ: 'リ', ﾙ: 'ル', ﾚ: 'レ', ﾛ: 'ロ', ﾜ: 'ワ', ｦ: 'ヲ', ﾝ: 'ン' }
  convertMap = { ...convertMap, ｧ: 'ァ', ｨ: 'ィ', ｩ: 'ゥ', ｪ: 'ェ', ｫ: 'ォ', ｯ: 'ッ', ｬ: 'ャ', ｭ: 'ュ', ｮ: 'ョ' }
  const reg = new RegExp('(' + Object.keys(convertMap).join('|') + ')', 'g')
  return str.replace(reg, function (match) { return convertMap[match] })
}

// 全角から半角へ変換
const zen2HanAll = function (str) {
  return zen2HanLtrNum(zen2HanSign(zen2HanKana(str)))
}
// 全角英数字を半角へ変換
const zen2HanLtrNum = function (str) {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  })
}

// 全角記号を半角へ変換
const zen2HanSign = function (str) {
  let convertMap = { '。': '｡', '、': '､', '「': '｢', '」': '｣', '･': '・', ゛: 'ﾞ' }
  convertMap = { ...convertMap, ゜: 'ﾟ', '”': '"', '‘': '\'', '￥': '\\', ー: '―' }
  const reg = new RegExp('(' + Object.keys(convertMap).join('|') + ')', 'g')
  str = str.replace(reg, function (match) { return convertMap[match] })
  const halfVal = str.replace(/[！-＠［-｀｛-～]/g, function (tempStr) {
    // 文字コードをシフト
    return String.fromCharCode(tempStr.charCodeAt(0) - 0xFEE0)
  })
  // 文字コードシフトで対応できない文字の変換
  return halfVal
}

// 全角カナから半角カナへ変換、半角全角変換では不十分らしい
const zen2HanKana = function (str) {
  let convertMap = { ガ: 'ｶﾞ', ギ: 'ｷﾞ', グ: 'ｸﾞ', ゲ: 'ｹﾞ', ゴ: 'ｺﾞ', ザ: 'ｻﾞ', ジ: 'ｼﾞ', ズ: 'ｽﾞ', ゼ: 'ｾﾞ', ゾ: 'ｿﾞ' }
  convertMap = { ...convertMap, ダ: 'ﾀﾞ', ヂ: 'ﾁﾞ', ヅ: 'ﾂﾞ', デ: 'ﾃﾞ', ド: 'ﾄﾞ', バ: 'ﾊﾞ', ビ: 'ﾋﾞ', ブ: 'ﾌﾞ', ベ: 'ﾍﾞ', ボ: 'ﾎﾞ' }
  convertMap = { ...convertMap, パ: 'ﾊﾟ', ピ: 'ﾋﾟ', プ: 'ﾌﾟ', ペ: 'ﾍﾟ', ポ: 'ﾎﾟ', ヴ: 'ｳﾞ', ヷ: 'ﾜﾞ', ヺ: 'ｦﾞ' }
  convertMap = { ...convertMap, ア: 'ｱ', イ: 'ｲ', ウ: 'ｳ', エ: 'ｴ', オ: 'ｵ', カ: 'ｶ', キ: 'ｷ', ク: 'ｸ', ケ: 'ｹ', コ: 'ｺ' }
  convertMap = { ...convertMap, サ: 'ｻ', シ: 'ｼ', ス: 'ｽ', セ: 'ｾ', ソ: 'ｿ', タ: 'ﾀ', チ: 'ﾁ', ツ: 'ﾂ', テ: 'ﾃ', ト: 'ﾄ' }
  convertMap = { ...convertMap, ナ: 'ﾅ', ニ: 'ﾆ', ヌ: 'ﾇ', ネ: 'ﾈ', ノ: 'ﾉ', ハ: 'ﾊ', ヒ: 'ﾋ', フ: 'ﾌ', ヘ: 'ﾍ', ホ: 'ﾎ' }
  convertMap = { ...convertMap, マ: 'ﾏ', ミ: 'ﾐ', ム: 'ﾑ', メ: 'ﾒ', モ: 'ﾓ', ヤ: 'ﾔ', ユ: 'ﾕ', ヨ: 'ﾖ' }
  convertMap = { ...convertMap, ラ: 'ﾗ', リ: 'ﾘ', ル: 'ﾙ', レ: 'ﾚ', ロ: 'ﾛ', ワ: 'ﾜ', ヲ: 'ｦ', ン: 'ﾝ' }
  convertMap = { ...convertMap, ァ: 'ｧ', ィ: 'ｨ', ゥ: 'ｩ', ェ: 'ｪ', ォ: 'ｫ', ッ: 'ｯ', ャ: 'ｬ', ュ: 'ｭ', ョ: 'ｮ' }
  const reg = new RegExp('(' + Object.keys(convertMap).join('|') + ')', 'g')
  return str.replace(reg, function (match) { return convertMap[match] })
}

// ---数値計算---
// カウンタ
const counter = function (str, seq) {
    return str.split(seq).length - 1
}

// 予め分かっている品詞の付与間違いの修正
const amendError = function (arglistSurf, arglistPos1) {
  // ミス記号一覧
  const errorList = ['＂', '，']
  // 記号の品詞の誤りを辞書的に直す
  for (let i = 0; i < arglistSurf.length; i++) {
    // 配列内に存在するかどうかを検索
    if (errorList.some((value) => { return value === arglistSurf[i] })) {
      arglistPos1[i] = '記号'
    }
  }
  return arglistPos1
}

export default {
  counter,
  han2ZenAll,
  han2ZenLtrNum,
  han2ZenSign,
  han2ZenKana,
  zen2HanAll,
  zen2HanLtrNum,
  zen2HanSign,
  zen2HanKana,
  amendError,
}
